(() => {
  const locale = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
  if (locale !== 'de') return;

  const replacements = [
    [/(?:Die\s+)?klassische\s+Routine(?:\s*\|\s*Classic\s+Routine)?/gi, 'Klassische Routine'],
    [/(?:Die\s+)?(?:fortgeschrittene|erweiterte)\s+Routine(?:\s*\|\s*Advanced\s+Routine)?/gi, 'Intensivroutine'],
  ];

  const normalizeText = (node) => {
    if (!node?.nodeValue || node.parentElement?.closest('script,style,noscript,template')) return;
    let next = node.nodeValue;
    for (const [pattern, replacement] of replacements) next = next.replace(pattern, replacement);
    if (next !== node.nodeValue) node.nodeValue = next;
  };

  const normalizeTree = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      normalizeText(root);
      return;
    }
    if (![Node.ELEMENT_NODE, Node.DOCUMENT_FRAGMENT_NODE, Node.DOCUMENT_NODE].includes(root.nodeType)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) normalizeText(node);
  };

  const start = () => {
    normalizeTree(document.body);
    const observer = new MutationObserver((records) => {
      observer.disconnect();
      for (const record of records) {
        if (record.type === 'characterData') normalizeText(record.target);
        for (const node of record.addedNodes) normalizeTree(node);
      }
      observer.observe(document.body, { subtree: true, childList: true, characterData: true });
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
